import { phaseBrickId } from '../../utils/phases';

// Phase de chaque brique (et de l'entrée « niveau phase » de chaque phase).
export function phaseByBrickId(clients) {
  const map = {};
  clients.forEach((c) =>
    (c.phases || []).forEach((ph) => {
      (ph.briques || []).forEach((b) => {
        map[b.id] = ph;
      });
      map[phaseBrickId(ph.id)] = ph;
    }),
  );
  return map;
}

const add = (obj, key, h) => {
  obj[key] = (obj[key] || 0) + h;
};

/* Heures saisies agrégées : par brique (map), par brique et membre (byDev), et par phase, jour et
   membre (daily, pour la facturation sur une plage libre). */
export function aggregateTimesheets(rows, phaseOf) {
  const map = {};
  const byDev = {};
  const daily = {}; // { [phaseId]: { [date]: { [devId]: heures } } } — pour Facturation, plage libre
  for (const row of rows) {
    const phase = phaseOf[row.brique_id];
    const h = parseFloat(row.heures || 0);
    // Facturation au réel : plage choisie par qui facture, jamais bornée par les dates de la
    // phase (contrairement à Financier/Marge juste en dessous) — une saisie antérieure au début
    // officiel de la phase doit rester facturable si elle tombe dans la plage demandée.
    if (phase) {
      daily[phase.id] ||= {};
      daily[phase.id][row.date] ||= {};
      add(daily[phase.id][row.date], row.dev_id, h);
    }
    // Une saisie hors de la fenêtre officielle de la phase (avant dateDebut ou après dateFin) ne
    // doit pas gonfler son suivi/coût — vécu en prod : une phase comptait des dizaines de saisies
    // faites avant sa propre date de début (voir discussion du 2026-09-04).
    if (phase && phase.dateDebut && row.date < phase.dateDebut) continue;
    if (phase && phase.dateFin && row.date > phase.dateFin) continue;
    add(map, row.brique_id, h);
    byDev[row.brique_id] ||= {};
    add(byDev[row.brique_id], row.dev_id, h);
  }
  return { map, byDev, daily };
}

/* Cache de consommation Jira relu depuis la base : heures par epic, par projet, par projet et
   mois (jira_key 'COGNLAB:2026-01') ou jour ('COGNLAB:2026-01-15'), et date de la dernière synchro. */
export function jiraCacheFromRows(rows) {
  const byEpic = {},
    byProject = {},
    byProjectMonth = {},
    byProjectDay = {};
  const byPeriod = { project_month: byProjectMonth, project_day: byProjectDay };
  let lastSync = null;
  for (const r of rows) {
    const h = parseFloat(r.heures || 0);
    if (r.kind === 'epic') byEpic[r.jira_key] = h;
    else if (r.kind === 'project') byProject[r.jira_key] = h;
    else if (byPeriod[r.kind]) {
      const colonIdx = r.jira_key.lastIndexOf(':');
      if (colonIdx > 0) {
        const projKey = r.jira_key.slice(0, colonIdx);
        (byPeriod[r.kind][projKey] ||= {})[r.jira_key.slice(colonIdx + 1)] = h;
      }
    }
    const t = new Date(r.synced_at);
    if (!lastSync || t > lastSync) lastSync = t;
  }
  return { byEpic, byProject, byProjectMonth, byProjectDay, lastSync };
}
